export default __webpack_public_path__ + "static/media/talk1.f99e7094.png";